type ApiJoinError = { response?: { data?: { error_message?: string } } }

const KNOWN_MESSAGES: Record<string, string> = {
  'Link inválido ou não encontrado.': 'Link inválido ou não encontrado.',
  'Esta campanha já foi encerrada.': 'Esta campanha já foi encerrada.',
  'Esta campanha ainda não está ativa.': 'Esta campanha ainda não está ativa.',
  'Esta campanha não está no período de participação.':
    'Esta campanha não está no período de participação.'
}

export function mapCampaignJoinErrorMessage(
  error: unknown,
  fallback = 'Não foi possível encontrar essa campanha. Verifique o código.'
): string {
  const apiMessage = (error as ApiJoinError)?.response?.data?.error_message
  if (!apiMessage) return fallback
  return KNOWN_MESSAGES[apiMessage] ?? apiMessage
}
